<template>
	<div class="publicity-content">
		<ul class="publicity-list">
			<li v-for="item in curData_" :key="item.id">
				<div class="publicity-img">
					<img src="~@/assets/img/lhc/fz-icon.png" />
				</div>
				<div class="publicity-title">{{item.title}}</div>
				<button class="btn-default" @click="goDetail(item.id)">查看详情</button>
				<div class="publicity-time">{{item.releaseTimestamp | time}}</div>
			</li>
		</ul>
		<ss-no-data v-if="!finish_ && busy_" text="数据加载中" />
		<ss-no-data v-else-if="finish_ && busy_ && curData_.length === 0" mode="image" text="暂无相关的信息" />
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					value: 'dxfydxfygs',
					label: '非遗公示'
				}]
			}
		},
		methods: {
			goDetail(id) {
				this.$router.push({
					path: '/lch/publicity/' + id
				})
			}
		}
	}
</script>

<style lang="scss">
	@import '~@/views/lch/css/publicity.scss';
</style>
